import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Common/Icon';

const DOWNLOAD_POINTS = [
  { icon: 'monitor', title: 'Desktop app', copy: 'Lifetime unlocks the private local-first app for focused review and offline use.' },
  { icon: 'shield-check', title: 'Version checked', copy: 'The download page confirms the current release before showing installers.' },
  { icon: 'download', title: 'Installer and notes', copy: 'Open the downloads page for the latest macOS installer, version, and release details.' }
];

const LandingDownloadsSection = React.memo(({ onGetDesktopApp }) => (
  <section id="downloads" className="landing-downloads-section" aria-labelledby="landing-downloads-title">
    <div className="landing-template-frame landing-downloads-frame">
      <div className="landing-downloads-copy">
        <p className="landing-downloads-kicker">Downloads</p>
        <h2 id="landing-downloads-title">Desktop downloads</h2>
        <p>
          Install the ThryveLoop desktop app when you want local-first control,
          offline access, manual sync, and a quieter place to review your loops.
        </p>
        <div className="landing-downloads-actions">
          <button type="button" className="landing-btn landing-btn--primary" onClick={onGetDesktopApp}>
            Open downloads
            <Icon name="arrow-right" size={16} />
          </button>
          <span className="landing-downloads-manifest">Checked against the current release</span>
        </div>
      </div>

      <div className="landing-downloads-visual" aria-label="Desktop download preview">
        <img
          src="/landing/desktop-workspace.jpg"
          alt="ThryveLoop desktop app shown on a monitor"
          loading="lazy"
        />
        <div className="landing-downloads-card">
          <span><Icon name="package" size={18} /></span>
          <div>
            <strong>Latest desktop release</strong>
            <p>Current DMG, release notes, and version checks in one place.</p>
          </div>
        </div>
      </div>

      <div className="landing-downloads-points">
        {DOWNLOAD_POINTS.map((point) => (
          <article key={point.title} className="landing-downloads-point">
            <span><Icon name={point.icon} size={18} /></span>
            <div>
              <h3>{point.title}</h3>
              <p>{point.copy}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
));

LandingDownloadsSection.propTypes = {
  onGetDesktopApp: PropTypes.func.isRequired,
};

LandingDownloadsSection.displayName = 'LandingDownloadsSection';

export default LandingDownloadsSection;
